import { RDSendReportComponent } from './rd-send-report.component';
export var rdSendReportRoutes = [
    {
        path: 'rdSendReport',
        component: RDSendReportComponent,
        data: {
            'expectedRoles': ['Accountant Admin', 'IT', 'Accountant']
        },
    },
];
var RDSendReportRoutingModule = (function () {
    function RDSendReportRoutingModule() {
    }
    return RDSendReportRoutingModule;
}());
export { RDSendReportRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report-routing.module.ts.pre-build-optimizer.js